/* eslint-disable no-unused-vars */
import React from 'react';
import MenuItem from '../menuItem/MenuItem';
import { useNavigate } from 'react-router-dom';

export const LocalizationActionList = ({ pages, activePage }) => {
  const navigate = useNavigate();
  const handleClick = (id, url) => {
    if (id === activePage.value) return;
    activePage.value = id;
    navigate(url);
  };

  return (
    <div>
      {pages.map((page) => (
        <MenuItem
          key={page.id}
          text={page.name}
          url={page.link}
          isActive={activePage.value === page.id}
          disabled={page.disabled}
          onClick={() => handleClick(page.id, page.url_id)}
        />
      ))}
    </div>
  );
};
